import { Flex, Stack } from '@talos/kyoko';
import styled from 'styled-components';

export const ModuleViewport = styled(Stack)`
  overflow: hidden;
  flex: 1;
`;

export const ModuleScrollContainer = styled(Flex)`
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModuleSection = styled.div<{ slideWidth: number }>`
  flex: 0 0 ${({ slideWidth }) => (slideWidth > 0 ? `${slideWidth}px` : 'auto')};
  width: ${({ slideWidth }) => (slideWidth > 0 ? `${slideWidth}px` : 'auto')};
  max-width: ${({ slideWidth }) => (slideWidth > 0 ? `${slideWidth}px` : 'auto')};
  min-width: 0;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
